// The magic resize string comes from PWT-8828.
export const addResizeVariablesToProductImage = (url?: string): typeof url =>
    url &&
    `${url}${
        url.indexOf('?') >= 0 ? '&' : '?'
    }function=resize&mimeType=image%2Fjpeg&aspectType=1&quality=75&cH=1152&cW=768&gravity=Center`;
